<template>
  <div class="wrapper">
    <div class="__container">
      <div class="form">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <div class="login_form">
          <h2>Create Password</h2>

          <label class="label">New Password</label>
          <input
            type="password"
            placeholder="Type your Password"
            class="password"
            v-model="confirmPassword"
            v-validate="'required'"
          />
          <label class="label">Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm your Password"
            class="password"
            v-validate="'required'"
            v-model="password"
            @keyup.enter="CreatePass()"
          />
          <div class="bottom">
            <consultfied-button
              :loading="is_loading"
              @click="CreatePass()"
              class="btn-create"
              >Create</consultfied-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
export default {
  name: "ai-create-account-password",
  computed: {},
  components: { consultfiedButton },
  mounted() {
    let vm = this;
    if (vm.$route.params.token) {
      vm.token = vm.$route.params.token;
    }
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      token: "",
      is_loading: false,
    };
  },
  methods: {
    CreatePass() {
      let vm = this;
      vm.is_loading = true;
      if (vm.password || vm.confirmPassword) {
        if (vm.confirmPassword === vm.password) {
          vm.$store
            .dispatch("AI_ACCOUNT_CHANGE_PASSWORD", {
              new_password: vm.password,
              token: vm.token,
            })
            .then((response) => {
              vm.is_loading = false;
              vm.$notify({
                group: "status",
                title: "Important message",
                text: "Password was now changed, Login now",
                type: "success",
                duration: 3000,
              });
              vm.$router.push({ name: "login" });
            })
            .catch(({ response }) => {
              vm.is_loading = false;
              console.error(response);
              vm.$notify({
                group: "status",
                title: "Something wrong",
                text: "Error while changing password, Please try again.",
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          vm.is_loading = false;
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Passwords do not much.",
            type: "warn",
            duration: 3000,
          });
        }
      } else {
        vm.$notify({
          group: "status",
          title: "Something wrong",
          text: "Passwords can not be empty.",
          type: "warn",
          duration: 3000,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/main";
@import url("https://fonts.googleapis.com/css?family=Shadows+Into+Light");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;

  overflow: hidden;
  background: #f2f2f2 url("../assets/images/backgrounds/logo_stamp2.svg");
  background-size: contain;
  z-index: 999999;
  background-repeat: no-repeat !important;
  background-position: center;
}
.__container {
  position: relative;
  display: inline-block;
  @media (min-width: 300px) and (max-width: 630px) {
  }
  .form {
    display: flex;
    align-items: center;
    flex-direction: column;
    .logo {
      margin-top: 40px;
      margin-bottom: 40px;
      @media (min-width: 300px) and (max-width: 630px) {
        position: relative;
      }
    }
    .message {
      margin-top: 30px;
      border-radius: 5px;
      padding: 2px 40px;
      color: #fff;
    }
    .success {
      background: rgba(24, 133, 173, 0.3);
    }
    .error {
      background: rgba(128, 0, 0, 0.3);
    }
    .login_form {
      margin-top: 40px;
      text-align: left;
      @media (min-width: 300px) and (max-width: 630px) {
        padding-left: 20px;
        padding-right: 20px;
      }
      h2 {
        margin-bottom: 30px;
        font-size: 18px;
        font-weight: normal;
        text-align: center;
      }
      .label-password {
        margin-top: 30px;
      }
      .label {
        color: #000;
        font-weight: normal;
        font-size: 14px;
        margin-bottom: 5px;
        margin-left: 20px;
        margin-top: 30px;
      }
      .error_input {
        border: 1px solid crimson !important;
        color: crimson;
      }
      .error-msg {
        color: crimson;
        text-align: left;
      }
      .input:focus {
        outline: none !important;
        box-shadow: none;
      }
      input[type="text"],
      input[type="password"],
      select {
        width: 400px;
        padding: 10px;
        height: 45px;
        background-color: #ffffff;
        border: 1px solid #ccc;
        @media (min-width: 300px) and (max-width: 630px) {
          width: 300px;
        }
        border-radius: 5px;
        background-size: 20px 15px;
        background-origin: content-box;
        background-repeat: no-repeat;
        &:focus {
          outline: none;
        }
      }
      .input-group {
        display: flex;
        margin-top: 30px;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        margin-bottom: 20px;
      }
      .email {
        background: url(../assets/icons/mail.png) right;
      }
      .password {
        background: url(../assets/icons/key.png) right;
      }
      .bottom {
        display: flex;
        margin-top: 20px;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .btn-create {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;

          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
      input[type="button"] {
        background: #1885ad;
        width: 150px;
        padding: 7px;
        border-radius: 5px;
        color: #fff;
        text-align: center;
      }
      input[type="checkbox"] {
        background-color: #ffffff;
      }
    }
    .logo,
    .login_form {
      display: flex;
      flex-direction: column;
    }
    .banner {
      margin-top: 30px;
    }
    .banner span {
      font-size: 16px;
      color: #000000;
      font-weight: lighter;
    }
    .banner h1 {
      font-weight: normal;
      text-align: center;
      font-size: 30px;
      color: #1ba5a4;
      margin-bottom: 2rem !important;
    }
  }
}
.accept-envitation-widget {
  display: flex;
  justify-content: center;
  background: #efefef;
  min-height: 100vh;
  padding-top: 90px;
  .form-widget {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    $column-space: 20px;
    width: 800px;
    padding-top: $column-space;
    height: 600px;
    .logo {
      margin-bottom: 30px;
      img {
        width: 80px;
      }
    }
    .title {
      color: #1ba5a4;
      font-size: 30px;
      font-family: "Nunito", sans-serif;
      margin-bottom: $column-space;
    }
    .input-widget {
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;
      margin-bottom: $column-space;
      .input-group {
        display: grid;
        grid-column-gap: 20px;
        input.dark {
          height: 47px;
          background: #efefef 0% 0% no-repeat padding-box;
          border-radius: 5px;
          padding: 0px 20px;
          color: #000;
          font-family: "Nunito", sans-serif;
          outline: none;
        }
        input.dark::placeholder {
          font-weight: 800;
        }
        input.light,
        select {
          height: 47px;
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 2px 6px #00000029;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 0px 20px;
          color: #000;
          font-family: "Nunito", sans-serif;
          outline: none;
        }
        textarea {
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 3px 3px #00000029;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 10px;
          outline: none;
        }
        .range-date {
          display: grid;
          grid-column-gap: 5px;
          grid-template-columns: auto auto;
          height: 47px;
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 2px 6px #00000029;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 4px 0px;
          padding-right: 10px;
          .date-field {
            background: #efefef;
            margin-left: 5px;
            height: 36px;
            border-radius: 5px;
            padding: 8px 10px;
            width: 100%;
            .date-field-input {
              width: 100% !important;
            }
          }
        }
      }
      .input-group.col-1 {
        grid-template-columns: auto;
      }
      .input-group.col-2 {
        grid-template-columns: auto auto;
      }
      .input-group.col-3 {
        grid-template-columns: auto auto auto;
      }
      .input-group.col-4 {
        grid-template-columns: auto auto auto auto;
        input,
        select {
          width: 147px;
        }
      }
    }
    .widget-options {
      margin-bottom: $column-space;
      .btn-submit {
        width: 234px;
        height: 48px;
        background: #1885ad 0% 0% no-repeat padding-box;
        border-radius: 5px;
        color: #fff;
        font-family: "Nunito", sans-serif;
        font-weight: 800;
      }
    }
  }
}
</style>
